/**
 * Execute a function when the DOM is fully loaded.
 *
 * @param {function} fn
 */
export const ready = (fn) =>
  document.readyState !== "loading" ? window.setTimeout(fn, 0) : document.addEventListener("DOMContentLoaded", fn);

/**
 * @AUHTOR SINGULAR-IT
 * WPML LANGUAGE SWITCHER
 */
let wpml_dom = document.getElementsByClassName("wpml-ls-native");
if (wpml_dom[0].lang == "en") {
  for (var i = 0; i < wpml_dom.length; i++) {
    wpml_dom[i].innerHTML = "EN";
  }
} else if (wpml_dom[0].lang == "de") {
  for (var i = 0; i < wpml_dom.length; i++) {
    wpml_dom[i].innerHTML = "DE";
  }
}

/**
 * FADE
 */
jQuery(window).on("load", function() {
  jQuery(window)
    .scroll(function() {
      var windowBottom = jQuery(this).scrollTop() + jQuery(this).innerHeight();
      jQuery(".fade").each(function() {
        /* Check the location of each desired element */
        var objectBottom = jQuery(this).offset().top + jQuery(this).outerHeight();

        /* If the element is completely within bounds of the window, fade it in */
        if (objectBottom < windowBottom) {
          //object comes into view (scrolling down)
          if (jQuery(this).css("opacity") == 0) {
            jQuery(this).fadeTo(1000, 1);
          }
        } else {
          //object goes out of view (scrolling up)
          if (jQuery(this).css("opacity") == 1) {
            jQuery(this).fadeTo(300, 0);
          }
        }
      });
    })
    .scroll(); //invoke scroll-handler on page-load
});

/**
 * @AUHTOR SINGULAR-IT
 * STICKY GLOSSY ELEMENT & PRESTIGE NEW
 */
var stickyTop = jQuery(".home").offset().top;
jQuery(".stickyyy").css("position", "fixed");
jQuery(".scroll-icon").css("position", "fixed");

jQuery(window)
  .scroll(function() {
    var windowTop = jQuery(window).scrollTop();
    if (
      !windowTop ||
      stickyTop > windowTop ||
      (stickyTop < windowTop &&
        jQuery(".blue").height() + jQuery(".blue").offset().top - jQuery(".stickyyy").height() - 300 > windowTop)
    ) {
      jQuery(".stickyyy").show();
      jQuery(".stickyyy").css("position", "fixed");
    } else {
      // jQuery('.stickyyy').fadeTo(300,0);
      jQuery(".stickyyy").hide();
    }

    if (
      !windowTop ||
      stickyTop > windowTop ||
      (stickyTop < windowTop &&
        jQuery(".front-animation").height() +
          jQuery(".front-animation").offset().top -
          jQuery(".scroll-icon").height() -
          700 >
          windowTop)
    ) {
      jQuery(".scroll-icon").show();
      jQuery(".scroll-icon").css("position", "fixed");
    } else {
      jQuery(".scroll-icon").hide();
    }
  })
  .scroll();

function getOuterHeight($elm) {
  var previousCss = $elm.attr("style");

  $elm.css({
    position: "absolute",
    visibility: "hidden",
    display: "block",
  });

  const optionHeight = $elm.outerHeight();

  $elm.attr("style", previousCss ? previousCss : "");

  return optionHeight;
}

var $prestigeNewContent = jQuery(".prestige-new-content");
var $main = jQuery("#main");
var $prestigeNewBackground = jQuery(".prestige-new-background");
var $window = jQuery(window);

var prestigeNewContentOuterHeight = getOuterHeight($prestigeNewContent);

jQuery(window).scroll(function() {
  if (window.screen.width < "2000") {
    var startAnim_fadeStart = 900;
    var startAnim_fadeEnd = -400;

    var endAnim_fadeStart = 900;
    var endAnim_fadeEnd = -400;
  } else {
    var startAnim_fadeStart = 1200;
    var startAnim_fadeEnd = -600;

    var endAnim_fadeStart = 1200;
    var endAnim_fadeEnd = -600;
  }

  var startAnim_scrollPosition =
    $prestigeNewBackground.offset().top - $window.scrollTop() - $window.height() + prestigeNewContentOuterHeight;
  var endAnim_scrollPosition = $main.offset().top - $window.scrollTop() - $window.height();

  if (startAnim_scrollPosition > startAnim_fadeStart || endAnim_scrollPosition < endAnim_fadeEnd) {
    $prestigeNewContent.hide();
  } else {
    $prestigeNewContent.show();
  }

  if (startAnim_scrollPosition < startAnim_fadeStart && startAnim_scrollPosition >= startAnim_fadeEnd) {
    var startAnim_opacity =
      1 - (startAnim_scrollPosition - startAnim_fadeEnd) / (startAnim_fadeStart - startAnim_fadeEnd);
    $prestigeNewContent.css("opacity", startAnim_opacity);
  } else if (endAnim_scrollPosition < endAnim_fadeStart && endAnim_scrollPosition >= endAnim_fadeEnd) {
    var endAnim_opacity = (endAnim_scrollPosition - endAnim_fadeEnd) / (endAnim_fadeStart - endAnim_fadeEnd);
    $prestigeNewContent.css("opacity", endAnim_opacity);
  } else {
    $prestigeNewContent.css("opacity", 0);
  }
});

if (jQuery("span.wpml-ls-native").html() == "EN") {
  var countdownFirstLine = "Buche innerhalb";
  var countdownSecondLine = "und erhalte die nächste Edition Gratis dazu!";
  var daysString = "Tage";
  var hoursString = "Stunden";
  var minutesString = "Minuten";
  var secondsString = "Sekunden";
  var noCountdownLine = "Buche jetzt und erhalte die nächste Edition gratis dazu!";
} else {
  var countdownFirstLine = "Book within";
  var countdownSecondLine = "and get the next edition for free!";
  var daysString = "Days";
  var hoursString = "Hours";
  var minutesString = "Minutes";
  var secondsString = "Seconds";
  var noCountdownLine = "Book now and get the next edition for free!";
}

//var countDownDate = new Date("Aug 19, 2021 14:00:00").getTime();
var countDownDate = new Date("Jul 02, 2022 23:59:59").getTime();

var x = setInterval(function() {
  var now = new Date().getTime();
  var distance = countDownDate - now;

  if (distance > 0) {
    document.getElementById("membership-banner_countdown").innerHTML =
      '<div class="membership-banner_countdown-text" style="padding-top: 2rem; padding-bottom: 0.75rem;">' +
      countdownFirstLine +
      "</div>" +
      '<div class="membership-banner_countdown-clock">' +
      '<div class="membership-banner_countdown-clock-time"><div class="membership-banner_countdown-clock-time-text">' +
      daysString +
      '</div><div class="membership-banner_countdown-clock-time-number" id="membership-banner_countdown-clock-time-days"></div></div>' +
      '<div class="membership-banner_countdown-clock-time"><div class="membership-banner_countdown-clock-time-text">' +
      hoursString +
      '</div><div class="membership-banner_countdown-clock-time-number" id="membership-banner_countdown-clock-time-hours"></div></div>' +
      '<div class="membership-banner_countdown-clock-time"><div class="membership-banner_countdown-clock-time-text">' +
      minutesString +
      '</div><div class="membership-banner_countdown-clock-time-number" id="membership-banner_countdown-clock-time-minutes"></div></div>' +
      '<div class="membership-banner_countdown-clock-time"><div class="membership-banner_countdown-clock-time-text">' +
      secondsString +
      '</div><div class="membership-banner_countdown-clock-time-number" id="membership-banner_countdown-clock-time-seconds"></div></div>' +
      "</div>" +
      '<div class="membership-banner_countdown-text" style="padding-top: 0.75rem; padding-bottom: 2rem;">' +
      countdownSecondLine +
      "</div>";

    // Time calculations for days, hours, minutes and seconds
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    document.getElementById("membership-banner_countdown-clock-time-days").innerHTML = days;
    document.getElementById("membership-banner_countdown-clock-time-hours").innerHTML = hours;
    document.getElementById("membership-banner_countdown-clock-time-minutes").innerHTML = minutes;
    document.getElementById("membership-banner_countdown-clock-time-seconds").innerHTML = seconds;
  }

  // Text when countdown is expired
  else {
    clearInterval(x);
    if (jQuery("span.wpml-ls-native").html() == "EN") {
      document.getElementById("membership-banner_countdown").innerHTML =
        '<div class="membership-banner_no-countdown-text" style="padding-top: 1rem; padding-bottom: 1rem;">Buche jetzt und erhalte die nächste Edition gratis dazu!</div>';
    } else {
      document.getElementById("membership-banner_countdown").innerHTML =
        '<div class="membership-banner_no-countdown-text" style="padding-top: 1rem; padding-bottom: 1rem;">Book now and get the next edition for free!</div>';
    }
  }
}, 1000);
